import { getMomentDate } from '../utils/commonUtils';
import User from './User';

export default class Ticket {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.ticketName = data.ticketName || undefined;
        this.actionType = data.actionType;
        this.notes = data.notes || undefined;
        this.priority = data.priority;
        this.status = data.status;
        this.assignerId = data.assignerId || undefined;
        this.assigneeId = data.assigneeId || undefined;
        this.setTicketData(data);
        this.orderCode = data.orderCode || undefined;
        this.orderId = data.orderId || undefined;
        this.orderItemType = data.orderItemType;
        this.contactFirstName = data.contactFirstName || undefined;
        this.contactLastName = data.contactLastName || undefined;
        this.contactEmail = data.contactEmail || undefined;
        this.contactPhone = data.contactPhone || undefined;
        this.createdDate = getMomentDate(data.createdDate);
        this.openedTime = getMomentDate(data.openedTime);
        this.closedTime = getMomentDate(data.closedTime);
        this.setHistories(data);
    }

    setTicketData(data={}){
        try {
            this.ticketData = JSON.parse(data.ticketData);
        } catch (e) {
            this.ticketData = undefined;
        }
    }

    setHistories(data){
        this.histories = (data.histories || []).map(item => new TicketHistory(item))
    }

    export(){
        return {
            id: this.id,
            ticketName: this.ticketName,
            actionType: this.actionType,
            notes: this.notes,
            priority: this.priority,
            status: this.status,
            assignerId: this.assignerId,
            assignerName: this.assignerName,
            assigneeId: this.assigneeId,
            assigneeName: this.assigneeName,
            ticketData: this.ticketData && JSON.stringify(this.ticketData),
            orderCode: this.orderCode,
            orderId: this.orderId,
            orderItemType: this.orderItemType,
            contactFirstName: this.contactFirstName,
            contactLastName: this.contactLastName,
            contactEmail: this.contactEmail,
            contactPhone: this.contactPhone,
            createdDate: this.createdDate && this.createdDate.toISOString(),
            openedTime: this.openedTime && this.openedTime.toISOString(),
            closedTime: this.closedTime && this.closedTime.toISOString(),
        }
    }

}

export class TicketAssignConfig {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.userId = data.userId || undefined;
        this.setUserDetail(data);
        this.orderItemType = data.orderItemType;
        this.workSessionFrom = data.workSessionFrom;
        this.workSessionTo = data.workSessionTo;
        this.isDisabled = data.isDisabled || false;

        this.sunday = data.sunday || false;
        this.monday = data.monday || false;
        this.tuesday = data.tuesday || false;
        this.wednesday = data.wednesday || false;
        this.thursday = data.thursday || false;
        this.friday = data.friday || false;
        this.saturday = data.saturday || false;
    }

    setUserDetail(data = {}) {
        this.userDetail = data.userDetail && new User(data.userDetail);
    }

    export() {
        return {
            id: this.id,
            userId: this.userId,
            userDetail: this.userDetail && this.userDetail.export(),
            orderItemType: this.orderItemType,
            workSessionFrom: this.workSessionFrom,
            workSessionTo: this.workSessionTo,
            isDisabled: this.isDisabled,

            sunday: this.sunday,
            monday: this.monday,
            tuesday: this.tuesday,
            wednesday: this.wednesday,
            thursday: this.thursday,
            friday: this.friday,
            saturday: this.saturday,
        }
    }
}

export class TicketHistory {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.ticketId = data.ticketId || undefined;
        this.fromUser = data.fromUser || undefined;
        this.toUser = data.toUser || undefined;
        this.fromStatus = data.fromStatus || undefined;
        this.toStatus = data.toStatus || undefined;
        this.actionType = data.actionType || undefined;
        this.actionBy = data.actionBy || undefined;
        this.actionTime = getMomentDate(data.actionTime);
    }

}